__turbopack_context__.v({
  "root": "map-pane-module-scss-module__khUdgq__root",
});
